import _extends from "@babel/runtime/helpers/esm/extends";
import { useSuperIntl } from "../_";
import { DownOutlined, EllipsisOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import React from 'react';
export var SuperProTableOption = function SuperProTableOption(properties) {
  var intl = useSuperIntl();
  return /*#__PURE__*/React.createElement(Dropdown, _extends({
    trigger: ['click']
  }, properties), /*#__PURE__*/React.createElement(Button, {
    type: properties.simple ? 'text' : undefined,
    icon: properties.simple ? /*#__PURE__*/React.createElement(EllipsisOutlined, null) : /*#__PURE__*/React.createElement(DownOutlined, null),
    style: {
      direction: 'rtl'
    }
  }, !properties.simple && intl.formatMessage({
    id: 'More Options'
  })));
};